import React, { useEffect } from "react";

export default function EmbedHtml(props) {
  const { embedHtml, cqPath, isInEditor, id } = props;

  const prefix = `embed-react-component`;

  const embedID = id ?? `${prefix}-${btoa(cqPath)}`;

  useEffect(() => {
    if (isInEditor) {
      return;
    }

    let reactDiv = document.getElementById(embedID);
    let currentDiv = document.getElementById(btoa(cqPath));

    while (currentDiv.firstChild) {
      reactDiv.appendChild(currentDiv.firstChild);
    }

    currentDiv.remove();
  }, [cqPath, embedHtml, isInEditor, embedID]);

  return isInEditor ? (
    <div
      style={{
        minHeight: "50px",
        display: "flex",
        alignItems: "center",
        backgroundColor: "#ffe1db",
      }}
    >
      <p>
        This component only works in
        <a style={{ display: "inline" }} href={"?wcmmode=disabled"}>
          View as Published
        </a>
        mode.
      </p>
    </div>
  ) : (
    <div id={embedID}></div>
  );
}
